// extracted by mini-css-extract-plugin
export default {"leftPart":"leftPart_leftPart__ITbyw","leftpart":"leftPart_leftpart__AGxp2"};